var throttle = require('./throttle');
var debounce = require('./debounce');

module.exports = {
	throttle: throttle,
	debounce: debounce
};



//////////////////
// WEBPACK FOOTER
// ./~/.store/throttle-debounce@1.1.0/~/throttle-debounce/index.js
// module id = 91
// module chunks = 0